import React, { useEffect, useState } from "react";
import {
    Card,
    Table,
    Pagination,
    Spin,
    Row,
    Col,
    Space,
    Button,
} from "antd";
import { BarChartOutlined, LeftOutlined, LoadingOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

import { VIEW_DOWNLOAD_REPORT_CAMPAIGN } from "../../../apis/apis";
import CulsightPageLoader from "../../../components/CulsightPageLoader";
import { formatToIST } from "../../../../helper/CommonHelper";

function ViewCampaignDownload() {
    const location = useLocation();
    const navigate = useNavigate();

    const download_report_id = location.state?.id;

    const [loader, setLoader] = useState(true);
    const [paginationLoader, setPaginationLoader] = useState(false);

    const [tableData, setTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [totalRows, setTotalRows] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const VIEW_DOWNLOAD_REPORT_LIST = async (
        page = currentPage,
        size = pageSize
    ) => {
        try {
            const FORM_DATA = new FormData();

            FORM_DATA.append("id", download_report_id);
            FORM_DATA.append("page", page);
            FORM_DATA.append("per_page", size);

            const API_CALL = await VIEW_DOWNLOAD_REPORT_CAMPAIGN(FORM_DATA);

            if (API_CALL?.data?.status) {
                setTableData(API_CALL?.data?.campaign_data || []);
                setCurrentPage(API_CALL?.data?.current_page);
                setTotalPages(API_CALL?.data?.total_pages);
                setTotalRows(API_CALL?.data?.total_rows);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
            setPaginationLoader(false);
        }
    };

    useEffect(() => {
        VIEW_DOWNLOAD_REPORT_LIST();
    }, []);

    const paginationOnChange = async (page, size) => {
        setPaginationLoader(true);

        setCurrentPage(page);
        setPageSize(size);

        VIEW_DOWNLOAD_REPORT_LIST(page, size);
    };

    const columns = [
        {
            title: "Campaign Name",
            dataIndex: "name",
        },
        {
            title: "SMTP",
            dataIndex: "smtp_name",
        },
        {
            title: "Group",
            dataIndex: "group_name",
        },
        {
            title: "Email Template",
            dataIndex: "email_template_name",
        },
        {
            title: "Stats",
            dataIndex: "stats",
            render: (_, record) => (
                <Space size="small" style={{ flexWrap: "nowrap" }}>
                    <span
                        style={{
                            fontWeight: "600",
                            color: "#8c3add",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Sent: {record.email_send || 0}
                    </span>

                    <span
                        style={{
                            fontWeight: "600",
                            color: "#1fa7a1",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Open: {record.email_open || 0}
                    </span>

                    <span
                        style={{ fontWeight: "600", color: "orange", whiteSpace: "nowrap" }}
                    >
                        Click: {record.email_clicked || 0}
                    </span>
                </Space>
            ),
        },

        {
            title: "Created On",
            dataIndex: "created_at",
            render: (text) => formatToIST(text),
        },

        {
            title: "Action",
            key: "action",
            render: (_, record) => (
                <Space>
                    <Button
                        type="primary"
                        onClick={() =>
                            navigate("/view-campaign/" + btoa(record.campaign_id), {
                                state: {
                                    from: "campaign-download",
                                    reportId: download_report_id,
                                },
                            })
                        }
                    >
                        <BarChartOutlined />
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <div className="lms-body">
            <Row>
                <Col span={24}>
                    <h2
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                        }}
                    >
                        <LeftOutlined
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate(-1)}
                        />
                        View Campaign Download Report
                    </h2>
                </Col>
            </Row>

            <Card>
                {loader ? (
                    <CulsightPageLoader />
                ) : (
                    <>
                        {paginationLoader ? (
                            <div style={{ textAlign: "center", padding: "60px" }}>
                                <Spin indicator={<LoadingOutlined spin />} size="large" />
                            </div>
                        ) : (
                            <Table
                                columns={columns}
                                dataSource={tableData}
                                pagination={false}
                                rowKey="campaign_id"
                            />
                        )}

                        {totalPages > 0 && (
                            <div style={{ float: "right", marginTop: "20px" }}>
                                <Pagination
                                    current={currentPage}
                                    total={totalRows}
                                    pageSize={pageSize}
                                    showSizeChanger
                                    pageSizeOptions={["10", "20", "50", "100"]}
                                    onChange={paginationOnChange}
                                    onShowSizeChange={(page, size) =>
                                        paginationOnChange(1, size)
                                    }
                                />
                            </div>
                        )}
                    </>
                )}
            </Card>
        </div>
    );
}

export default ViewCampaignDownload;